import React from "react";

export const DevicesBanner: React.FC = () => (
  <div className="container">
    <div className="row justify-content-md-center">
      <div className="col col-md-8 text-center p-2">
        You can encounter bugs on mobile devices or Safari browser. Until I fix
        them, better use Chrome/Brave/Firefox on your laptop.
      </div>
    </div>
  </div>
);
